'use client';
import { useCurrencyString } from '@repo/ui/src/hooks/useCurrencyString';
import { classNames } from '@repo/ui/src/utils/classNames';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import React from 'react';

interface SummaryLineProps {
  title: string;
  value: number | null;
  currency?: string;
  bold?: boolean;
  freeLabel?: string;
}

const SummaryLine = ({ title, value, bold, currency, freeLabel }: SummaryLineProps) => {
  const getCurrencyString = useCurrencyString(currency);
  const { t } = useTranslation();
  const free = value === 0;

  const freeText =
    freeLabel || t('addToCartWindowContent.freeLabel', undefined, { default: 'Free' });

  return (
    <div className="flex justify-between">
      <p
        className={classNames(
          'tra-text-web-body-m mt-1 m-0',
          bold ? 'tra-text-web-heading-7 font-bold' : 'tra-text-web-body-m',
        )}
      >
        {title}
      </p>
      <p
        className={classNames(
          'tra-text-web-body-m mt-1 m-0 text-right',
          bold ? 'tra-text-web-heading-7 font-bold' : 'tra-text-web-body-m',
        )}
      >
        {free ? freeText : getCurrencyString(value)}
      </p>
    </div>
  );
};

export default SummaryLine;
